import React, {Component} from 'react';

import axios from 'axios';
import moment from "moment";
import swal from 'sweetalert2';
import Dropzone from 'react-dropzone'
import {SkyLightStateless} from "react-skylight";

import urls from '../../../../utils/urls';
import {apiToken, tokenHeader} from '../../../../utils/headers';
import {Spinner} from "../../../../components/Loading/Spinner";


export default class TripBulkUpload extends Component {

    constructor(props) {
        super(props);

        this.state = {
            files: [],
            showModal: false,
            sendingFiles: false,
            showErrors: false
        }
    }

    _onDrop = (files) => {
        if (files.length === 1) {
            let stateFiles = this.state.files;
            files.forEach(file => {
                let found = false;
                this.state.files.forEach(stateFile => {
                    if (stateFile.name === file.name) {
                        found = true;
                    }
                });
                if (!found) {
                    stateFiles=[];
                    stateFiles.push(file);
                }
            });
            this.setState({files: stateFiles});
        }else{
            swal({
                title: `Carga masiva de viajes`,
                html: `No se han podido procesar los archivos cargados. Por favor, cargue un archivo a la vez.`,
                type: 'error',
                showConfirmButton: false,
                timer: 2000
            });
        }
    };

    _onDropRejected = () => {
        swal({
            title: `Carga masiva de viajes`,
            html: `No se han podido procesar los archivos cargados. Por favor, asegurese de subir un archivo Excel (.xlsx) no mayor a 10 megas.`,
            type: 'error',
            showConfirmButton: false,
            timer: 2000
        });
    };

    _sendFiles = () => {
        if (this.state.files.length === 0) return false;

        this.setState({sendingFiles: true}, this._postFile);
    };

    _postFile = () => {

        if(this.state.files.length === 0) return false;

        const upload_url = `${urls.API_ROOT}/api/v1/bulk/trip/`;

        let headers = tokenHeader();
        headers['headers']['content-type'] = "multipart/form-data";

        let formData = new FormData();
        formData.append("xlsx", this.state.files[0]);
        axios
            .post(upload_url, formData, headers)
            .then(() => {
                if(this.props.refreshAction) this.props.refreshAction();

                this.setState({ showModal: false, sendingFiles: false, files: []}, () => {
                    swal({
                        title: `Carga masiva de viajes`,
                        html: 'El archivo se ha subido correctamente',
                        type: 'success',
                        showConfirmButton: false,
                        timer: 2000
                    });
                });
            })
            .catch((error) => {

                if (error && error.response && error.response.hasOwnProperty('status')) {
                    let status = error.response.status;

                    if (status === 403 || status === 400) {
                        this.setState({sendingFiles: false, files: [], errors: error.response.data, showErrors: true});
                    }
                }else{
                    this.setState({sendingFiles: false, files: []});
                    swal({
                        title: `Carga masiva de viajes`,
                        html: `No se han podido procesar los archivos cargados. Por favor, intentelo nuevamente.`,
                        type: 'error',
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            });
    };

    _closeModal = () => {

        if(this.state.sendingFiles) return false;

        this.setState({
            showModal:false,
            files: []
        });
    };

    _downloadTemplate = () => {
        let TEMPLATE_URL = `${urls.API_ROOT}/api/v1/bulk/trip/`;
        try{
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                let a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    let filename = `Plantilla Viajes Fame y Ethanol - ${moment().format('DD-MM-YYYY')}.xlsx`;
                    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                        //IE 10+
                        window.navigator.msSaveBlob(xhttp.response, filename);
                    }else{
                        // Trick for making downloadable link
                        a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhttp.response);
                        // Give filename you wish to download
                        a.download = filename;
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                    }
                }else if(xhttp.status >= 300){
                    swal({
                        title: `Carga masiva de viajes`,
                        html: `En este momento no puede realizarse la descarga de la plantilla. Intentelo más tarde.`,
                        type: 'error',
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            }
            // Post data to URL which handles post request
            xhttp.open("GET", TEMPLATE_URL);
            xhttp.setRequestHeader("Authorization", `Token ${apiToken()}`);
            // You should set responseType as blob for binary responses
            xhttp.responseType = 'blob';
            xhttp.send();
        }
        catch(e){
            console.log(e);
        }
    };

    componentDidMount() {
        this.setState({_notificationSystem: this.refs.notificationSystem});
    }

    render() {

        let buttonClassCancel = this.state.sendingFiles ? 'disabled' : '';
        let buttonClassSubmit = this.state.sendingFiles || this.state.files.length === 0 ? 'disabled' : '';

        let dropZoneStyle = {
            width: '100%',
            height: '200px',
            padding: '10px 20px',
            border: "2px #bcbcbc dashed",
            borderRadius: "5px",
            overflowY: "auto"
        };

        let dropZoneActive = {
            border: "2px #008443 solid",
            background: "#f7f7f7"
        };

        let dropZoneReject = {
            border: "2px #DD1D21 solid",
            background: "#fff",
            color: "rgba(0,0,0,0.1)",
        };

        return (
            <div style={{display: 'inline-block'}}>
                <button className={"btn btn-shell-empty z-depth-0"} onClick={() => this.setState({showModal: true})}>
                    Cargar Excel
                </button>

                <div style={{position: 'absolute'}}>
                    <SkyLightStateless
                        onOverlayClicked={this._closeModal}
                        isVisible={this.state.showModal}
                        onCloseClicked={this._closeModal}
                        title={<div className="modal-title center">Carga Masiva de Viajes</div>}
                    >
                        <div className={"center"} style={{padding: '0 50px'}}>
                            {!this.state.showErrors &&
                            <div>
                                <p>Para descargar una plantilla vacía, haga <span onClick={this._downloadTemplate} className={'fake-anchor'}>click aquí</span>.</p>
                                <Dropzone
                                    style={dropZoneStyle}
                                    multiple={false}
                                    disabled={this.state.sendingFiles}
                                    disableClick={this.state.sendingFiles}
                                    activeStyle={dropZoneActive}
                                    rejectStyle={dropZoneReject}
                                    maxSize={11000000}
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    onDropRejected={this._onDropRejected}
                                    onDrop={this._onDrop}>
                                    {this.state.files.length === 0 &&
                                    <div>
                                        <p className="center">
                                            Arrastre su archivo o haga click para buscarlo
                                        </p>
                                        <div className={"col s4 offset-s4 center"}>
                                            <img src="/static/images/excel-icon.png"
                                                 className="dropzone-icon"
                                                 alt="Excel icon"/>
                                        </div>
                                    </div>
                                    }

                                    {this.state.files.length > 0 &&
                                    <div>
                                        {this.state.sendingFiles ? <p>Enviando archivos: </p> : <p>Archivos a enviar: </p>}
                                        <ul>
                                            {
                                                this.state.files.map(f => <li key={f.name}>{f.name}</li>)
                                            }
                                        </ul>
                                        {this.state.sendingFiles && <Spinner /> }
                                    </div>
                                    }
                                </Dropzone>
                                <div className={'margin-top-20'}>
                                    <button className={`btn btn-shell-empty z-depth-0 ${buttonClassCancel}`} onClick={this._closeModal}>
                                        Cancelar
                                    </button>
                                    <button className={`btn btn-shell z-depth-0 ${buttonClassSubmit}`} onClick={this._sendFiles}>
                                        Enviar
                                    </button>
                                </div>
                            </div>
                            }

                            {this.state.showErrors &&
                            <div>
                                <div className="modal-title center">No se pudo cargar el archivo, se encontraron los siguientes errores:</div>
                                <div style={{overflowY: 'auto', height: 200, textAlign: 'left', border: '1px solid #c9c9c9', background: '#F7F7F7', padding: 10}}>
                                    {this.state.errors && this.state.errors.map(error => {
                                        return <div>&bull; {error}</div>
                                    })}
                                </div>
                                <div className={'margin-top-20'}>
                                    <button className={`btn btn-shell-empty z-depth-0`} onClick={this._closeModal}>
                                        Cancelar
                                    </button>
                                    <button className={`btn btn-shell z-depth-0`} onClick={() => this.setState({errors: [], showErrors: false})}>
                                        Cargar otro archivo
                                    </button>
                                </div>
                            </div>
                            }

                        </div>
                    </SkyLightStateless>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Home/FE/TripBulkUpload.js